import React from 'react'

import { Card, Flex, Header, SimpleGrid, styled, Tabs, Text } from '@driftt/dds'

import {
  AverageCSAT,
  DeadEndChats,
  FirstResponse,
  ResponseRate,
} from 'components/routing/KPICards'
import { RoutingFirstExperienceModal } from 'components/routing/RoutingOutcomesFirstExperience'
import { RoutingSankey } from 'components/routing/RoutingSankey'
import { hasFullRoutedChatAccess } from 'utils/access'

import Teammates from './Teammates'

const StyledTabs = styled('div', {
  width: '100%',
})

const LiveChatTabContent = () => {
  return (
    <Card>
      <Card.Header>
        <Header variant="h3">Live chat journey</Header>
        <Text variant="metadata">
          What happens when a visitor wants to speak to someone?
        </Text>
      </Card.Header>
      <Card.Content>
        <RoutingSankey />
      </Card.Content>
    </Card>
  )
}

const RoutingReportV2 = () => {
  const showAllTabs = hasFullRoutedChatAccess()
  const tabsOptions = [
    {
      label: 'Chat journey',
      value: 'chatJourney',
      content: <LiveChatTabContent />,
    },
    {
      label: 'Teammates',
      value: 'teammates',
      content: <Teammates />,
    },
  ]

  return (
    <Flex fullWidth direction="column" gap={3}>
      <RoutingFirstExperienceModal />
      <SimpleGrid fullWidth columns={4} gap={3}>
        <ResponseRate />
        <FirstResponse />
        <DeadEndChats />
        <AverageCSAT />
      </SimpleGrid>
      {showAllTabs ? (
        <StyledTabs>
          <Tabs options={tabsOptions} />
        </StyledTabs>
      ) : (
        <Teammates />
      )}
    </Flex>
  )
}

export default RoutingReportV2
